import request from '../../constants/fetch';
import queryString from 'query-string';
import pickBy from 'lodash/pickBy';

 /**
 * API Get pricing list
 * @returns {Promise<unknown>}
 */
export const getPricingService = (query, options = {}) => 
    request.get(`/pricing?${queryString.stringify(pickBy(query, item => item !== ""), { arrayFormat: 'comma' })}`, options);

/**
 * API Get branchs list
 * @returns {Promise<unknown>}
 */
export const getBranchsPricingService = (query, options = {}) => 
  request.get(`/pricing/branch`, options);

/**
 * API Get languages list
 * @returns {Promise<unknown>}
 */
export const getLanguagesPricingService = (query, options = {}) => 
  request.get(`/pricing/language`, options);
  
/**
 * API Get words list
 * @returns {Promise<unknown>}
 */
export const getWordsPricingService = (query, options = {}) => 
  request.get(`/pricing/word`, options);

/**
 * API Get completion times list
 * @returns {Promise<unknown>}
 */
export const getCompletionTimesPricingService = (query, options = {}) => 
  request.get(`/pricing/completion-time`, options);

 /**
 * API Get pricing by id
 * @param id
 * @returns {Promise<unknown>}
 */
export const getPricingByIdService = (id, options = {}) => 
    request.get(`/pricing/byId/${id}`, options);

/**
 * API Edit price
 * @returns {Promise<unknown>}
 */
export const editPriceService = (id, data, options = {}) => 
  request.put(`/pricing/update/${id}`, data, options);

/**
 * API Add new price
 * @returns {Promise<unknown>}
 */
export const addNewPriceService = (data) => {
  return request.post(`/pricing`, data);
}